module.exports = __webpack_public_path__ + "img/about-img.79439fc4.jpg";